// extracted by mini-css-extract-plugin
export var hidden = "_4g-1";
export var leftPanel = "_4g-2";
export var readonlyInspector = "_4g-3";
export var rightPanel = "_4g-0";